export default __webpack_public_path__ + "images/2c212d85277a7609cda7f2a17ac82244.svg";